<template>
    <div id="app" class="container_100">
        <login :isTx="isTx" v-if="showLogin" />
        <layout v-else />
        <!-- <layout class="show" /> -->
    </div>
</template>

<script>
import layout from '_c3/layout';
import login from '_c3/login';

export default {
    name: 'app',
    data() {
        return {
            collapsed: false,
        }
    },
    created(){},
    components: {
        layout,
        login,
    },
    mounted(){
    },
    computed: {
        showLogin() {
            return this.$store.getters.showLogin
        },
        isTx() {
            const hostName = window.location.hostname
            const protocol = window.location.protocol
            return `${protocol}//${hostName}` === process.env.TX_HOST
        }
    },
}
</script>
<style lang="less">
@import "~_css/common.less";
@import "~_css/main.less";
</style>



// WEBPACK FOOTER //
// src/App_v3.vue